//#region src/lib/hierarchy-sort.ts
var e = /* @__PURE__ */ function(e) {
	return e.Default = "default", e.Alphabetical = "alphabetical", e.ReverseAlphabetical = "reverse-alphabetical", e;
}({});
//#endregion
export { e as HierarchySortOption };
